import { render, staticRenderFns } from "./OrderViewList.vue?vue&type=template&id=6bfb79fd"
import script from "./OrderViewList.vue?vue&type=script&lang=js"
export * from "./OrderViewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports